const Layers = () => (
  <>
    <path
      fill="currentColor"
      d="M5.121 14.407a.48.48 0 0 1-.195-.383.5.5 0 0 1 .182-.403.5.5 0 0 1 .311-.104.5.5 0 0 1 .312.104l5.885 4.551a.61.61 0 0 0 .768 0l5.885-4.551a.5.5 0 0 1 .312-.104.5.5 0 0 1 .311.104q.189.165.182.402a.48.48 0 0 1-.195.384l-5.885 4.558a1.6 1.6 0 0 1-.994.348q-.54 0-.994-.348zm5.885.739-4.75-3.687a1.53 1.53 0 0 1-.621-1.267q0-.783.62-1.267l4.75-3.687q.455-.348.995-.348t.994.348l4.75 3.687q.622.484.622 1.267t-.622 1.267l-4.75 3.687a1.6 1.6 0 0 1-.994.348q-.54 0-.994-.348m1.378-.793 4.732-3.68a.584.584 0 0 0 0-.962l-4.732-3.68a.61.61 0 0 0-.768 0L6.885 9.71a.584.584 0 0 0 0 .961l4.73 3.681a.61.61 0 0 0 .77 0"
    />
  </>
)
export default Layers
